import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../../../theme';
import { useIsMobile } from '../../../../../../utils';
import { BaseButton } from '../../../../../../BaseComponents';

import {
	getSelectedSegmentMinDate,
	getSelectedSegmentOnLeg,
	getSelectedSegmentsDates,
	transformSegmentToParams
} from '@entities/exchange';
import { CdnIcon } from '@shared/ui';

import { SelectDate } from '../SelectDate';
import { useSelectSegmentDate } from '../../model/useSelectSegmentDate';

interface Props {
	segmentId: string;
}

const SelectSegmentDate: React.FC<Props> = ({ segmentId }) => {
	const { t } = useTranslation('Exchange');
	const { SelectSegmentDate: theme } = useTheme('Features').Exchange;

	const isMobile = useIsMobile();

	const selectedSegment = useSelector(getSelectedSegmentOnLeg);
	const selectedSegmentMinDate = useSelector(getSelectedSegmentMinDate);
	const selectedSegmentsDates = useSelector(getSelectedSegmentsDates);

	const { onSetSegmentDate } = useSelectSegmentDate();

	const onSelectSegmentDate = useCallback(
		(date: Date) => {
			onSetSegmentDate(segmentId, date);
		},
		[segmentId, onSetSegmentDate]
	);

	return (
		<SelectDate
			date={selectedSegment.selectedDate}
			minDate={selectedSegmentMinDate}
			selectedDates={selectedSegmentsDates}
			segmentSearchParams={transformSegmentToParams(selectedSegment)}
			renderTrigger={onOpen =>
				isMobile ? (
					<div className={theme.root} onClick={onOpen}>
						<CdnIcon icon="Action/Show Calendar" />
						<span className={theme.label}>{t('Flights.ChangeDate')}</span>
					</div>
				) : (
					<BaseButton variant="text" onClick={onOpen} endIcon={<CdnIcon icon="Action/Show Calendar" />}>
						{t('Flights.ChangeDate')}
					</BaseButton>
				)
			}
			onSelectDate={onSelectSegmentDate}
			isSelected
		/>
	);
};

export default SelectSegmentDate;
